module.exports = __webpack_public_path__ + "static/media/fb-create-adaccount-7-es.7ffaf3ed.png";